import { combineUint8Arrays } from '../utils/utils';
import { getDeviceGroupVaultEntryBytesToBeSigned } from '../vault/device-group-vault/device-group-utils';
import { DeviceGroupVault } from '../vault/device-group-vault/device-group-vault';
export class DeviceGroupService {
    constructor(cryptoService, deviceGroupVaultRepository, logger) {
        this.cryptoService = cryptoService;
        this.deviceGroupVaultRepository = deviceGroupVaultRepository;
        this.logger = logger;
    }
    async isDeviceGroupVaultInitialized(companyId) {
        const deviceGroupEntriesResponse = await this.deviceGroupVaultRepository.loadDeviceGroupVaultEntries(companyId);
        return deviceGroupEntriesResponse.entries.length !== 0;
    }
    async getDeviceGroupVault(companyId, vault, allowEmpty = false) {
        const deviceGroupEntriesResponse = await this.deviceGroupVaultRepository.loadDeviceGroupVaultEntries(companyId);
        const deviceGroupVault = await DeviceGroupVault.Create(deviceGroupEntriesResponse.entries, vault, allowEmpty, deviceGroupEntriesResponse.cachedEntryCount);
        if (deviceGroupEntriesResponse.entries.length === 0 || deviceGroupEntriesResponse.entries.length !== deviceGroupEntriesResponse.cachedEntryCount) {
            try {
                this.deviceGroupVaultRepository.saveDeviceGroupVaultEntriesInLocalStorage(companyId, deviceGroupEntriesResponse.entries);
            }
            catch (ex) {
                this.logger.logWarning(`Device Group Service: ${ex}`);
            }
        }
        return deviceGroupVault;
    }
    async addDeviceGroupVaultEntry(lastDeviceGroupEntry, groupId, groupName, userId, operation, signingContext) {
        const newEntry = {
            entryId: lastDeviceGroupEntry ? lastDeviceGroupEntry.entryId + 1 : 0,
            groupId,
            groupName,
            addedAt: signingContext.timeSource.now(),
            userId,
            vaultEntryId: signingContext.signerEntry.id,
            operation: operation,
            version: 1,
        };
        // sign: entry signature
        const entrySignature = new Uint8Array(await this.cryptoService.sign(signingContext.keyPair.privateKey, getDeviceGroupVaultEntryBytesToBeSigned(newEntry)));
        let blockchainSignature;
        if (lastDeviceGroupEntry) {
            // sign: blockchain signature
            const blockChainSignaturePayload = combineUint8Arrays(lastDeviceGroupEntry.blockchainSignature, entrySignature);
            blockchainSignature = new Uint8Array(await this.cryptoService.sign(signingContext.keyPair.privateKey, blockChainSignaturePayload));
        }
        else {
            blockchainSignature = entrySignature;
        }
        // add device group
        this.logger.logInformation('Device Group Service: Add device group request');
        await this.deviceGroupVaultRepository.addDeviceGroupVaultEntry(Object.assign({ entrySignature, blockchainSignature }, newEntry));
    }
}
